import { render } from "./EditNameTh.vue?vue&type=template&id=367c75a2"
import script from "./EditNameTh.vue?vue&type=script&lang=js"
export * from "./EditNameTh.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__